module.exports = __webpack_public_path__ + "static/media/plus-icon.9bf2c6ac.svg";